import React, { useEffect } from "react";

import { useTranslation } from "../../../../../hooks";
import LayoutRow from "../../components/LayoutRow";
import ChainNameSingleSelection from "../../components/rent/ChainNameSingleSelection";
import DurationSingleSelection from "../../components/rent/DurationSingleSelection";
import WalletAddressDisplayOnlyField from "../../components/rent/WalletAddressDisplayOnlyField";
import RentPricingTable from "../../RentRequestTab/components/RentPricingTable";
import { RentDialogFields } from "../../types";

interface IProps {
  fields: RentDialogFields;
  setFields: React.Dispatch<React.SetStateAction<RentDialogFields>>;
  rowData?: any;
}

const BalanceTabRentDialogContent = (props: IProps) => {
  const { fields, setFields, rowData } = props;

  const { t } = useTranslation("tronWalletResourceBalance");

  const DEFAULT_CHAIN_NAME = "TRX";

  useEffect(() => {
    // default to TRX
    if (!fields.chainName) {
      setFields({
        ...fields,
        chainName: DEFAULT_CHAIN_NAME,
      });
    }
  }, []);

  const clearSelect = (fieldKey: string) => {
    setFields({
      ...fields,
      [fieldKey]: "",
    });
  };

  const updateField = (fieldKey: string, value: any) => {
    setFields({
      ...fields,
      [fieldKey]: value,
    });
  };

  return (
    <div>
      <LayoutRow
        title={t("chainName")}
        content={<ChainNameSingleSelection value={"TRX"} onChange={() => {}} />}
      />

      <LayoutRow
        title={t("receivingAddress")}
        content={
          <WalletAddressDisplayOnlyField value={rowData?.wallet_address} />
        }
      />

      <LayoutRow
        title={t("duration")}
        content={
          <DurationSingleSelection
            value={fields.duration || ""}
            onChange={(event) => updateField("duration", event.target.value)}
            onClear={() => clearSelect("duration")}
          />
        }
      />

      <div
        style={{
          height: "1px",
          backgroundColor: "rgba(0,0,0,0.2)",
          margin: "20px 0 12px",
        }}
      ></div>

      {/* new section */}
      <div>
        <RentPricingTable setFields={setFields} />
      </div>

      {/* <LayoutRow
        title={t("energyAmount")}
        subtitle={
          <Button
            onClick={() => {
              setIsGuidanceDialogOpen(true);
            }}
            sx={{ textTransform: "none", padding: 0 }}
          >
            {t("rentResourceGuidance")}
          </Button>
        }
        content={
          <NumberOfTransactionEnergyTextField
            label={t("phEnergyAmount")}
            value={fields.numberOfTransactionEnergy || ""}
            onChange={(event) =>
              updateField("numberOfTransactionEnergy", event.target.value)
            }
          />
        }
      /> */}
      {/* <LayoutRow
        title={t("bandwidthAmount")}
        subtitle={
          <Button
            onClick={() => {
              setIsGuidanceDialogOpen(true);
            }}
            sx={{ textTransform: "none", padding: 0 }}
          >
            {t("rentResourceGuidance")}
          </Button>
        }
        content={
          <NumberOfTransactionBandwidthTextField
            label={t("phBandwidthAmount")}
            value={fields.numberOfTransactionBandwidth || ""}
            onChange={(event) =>
              updateField("numberOfTransactionBandwidth", event.target.value)
            }
          />
        }
      /> */}

      {/* <LayoutRow
        title={t("orderId")}
        content={
          <OrderIdTextField
            value={fields.orderId || ""}
            onChange={(event) => updateField("orderId", event.target.value)}
          />
        }
      /> */}
    </div>
  );
};

export default BalanceTabRentDialogContent;
